/**
 * A mock interface for the NAVBAR SCS
 * See https://github.com/optimizely/optimizely/tree/devel/src/www/frontend/src/js/bundles/navbar
 */
export const actions = {
  pushBreadcrumbStack: (item: any) => {},
  setActiveNavItem: (item: any) => {},
  setActiveTab: (category: any, tab: any) => {},
  setBreadcrumbStack: (stack: string) => {},
  setNavWidth: (width: any) => {},
  showSupportDialog: (props?: { [key: string]: any }) => {},
};

export const constants = {
  NavItems: {
    FLAGS: 'FLAGS',
    REPORTS: 'REPORTS',
  },
  NavWidth: {
    COLLAPSED: 'COLLAPSED',
    HIDDEN: 'HIDDEN',
    OPEN: 'OPEN',
  },
};

export const subscribe = (type: string, handler: (value: any) => void) => {
  return () => {};
};

type BeforeLeaveFn = null | (() => Promise<any>);

export const setBeforeLeave = (beforeLeaveFn: BeforeLeaveFn) => {};

const navbar = {
  actions,
  constants,
  setBeforeLeave,
  subscribe,
};

export default navbar;
